module.exports = {
  footerText: '',
}
